module.exports = {
  footerText: '',
}
